export { default } from './Drawer';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Drawer/index.js
// module id = 321
// module chunks = 0